import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { fetchProducts } from "../lib/api";
import { scrollToId } from "../lib/ui";
import { Hero } from "../components/Hero";
import { EditorialMarquee } from "../components/Marquee";
import { ProductGrid } from "../components/ProductGrid";
import { Manifesto } from "../components/Manifesto";
import { CoaScience } from "../components/CoaScience";
import { Newsletter } from "../components/Newsletter";

export default function Home() {
  const location = useLocation();
  const { data: products = [], isLoading } = useQuery({ queryKey: ["products"], queryFn: fetchProducts });

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => scrollToId(id), 400);
    }
  }, [location]);

  return (
    <div data-testid="home-page">
      <Hero />
      <EditorialMarquee />
      {isLoading ? (
        <div className="flex h-64 items-center justify-center bg-sand">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-ink/40">Loading catalog…</span>
        </div>
      ) : (
        <ProductGrid products={products} />
      )}
      <Manifesto />
      <CoaScience />
      <Newsletter />
    </div>
  );
}
